module.exports = __webpack_public_path__ + "static/img/pete_pictgrid18_800x800.f8ed1b9.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/pete_pictgrid18_800x800.jpg
// module id = w/S4
// module chunks = 0